<template>
<div>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{message}}</span>
      </v-snackbar>
      <v-card class="neu-glow mt-n2 mb-3">
        <v-card-title primary-title>
          <div class="text-h5">Assegnazione Turni</div>
          <v-spacer></v-spacer>
          <v-div class="mr-1 mt-1">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="activeSlots_hash==JSON.stringify(activeSlots)" @click.stop="saveActiveSlots()">
                  <v-icon color="error">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>                                     
          </v-div> 
        </v-card-title>
        <v-alert 
          v-if="activeSlots&&activeSlots.filter(s => s.shiftId===null).length"
          class="mx-5 text-h6 mb-5"
          color="error"
          dismissible
          dense
          type="error"
        >
          Attenzione: gli Slots evidenziati in rosso non sono collegati a nessun turno: scegliere per ognuno un turno e salvare
        </v-alert>
        <v-row v-if="!allShifts">
            <v-col class="text-center">
              <v-progress-linear
                color="info"
                height="10"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
        </v-row>
        <v-row v-else class="px-8 pb-5 d-block">
          <v-card class="d-flex" elevation="8">
            <v-col cols="12" md="6" :lg="12/cols" class="flex-wrap" v-for="(c,ci) in Columns" :key="ci" >
              <v-row :key="si" v-for="(s,si) in c" class="mb-1">
                <v-col cols="3" sm="4" md="4" class="text-center">
                  <v-text-field
                    v-model="s.slotName"
                    name="slot"
                    outlined
                    dense
                    readonly
                    reverse
                    hide-details
                  ></v-text-field>   
                </v-col>
                <v-col cols="9" sm="8" md="8" class="text-center">
                  <v-select
                    :class="!activeSlots[si+ci*mid].shiftName?'red lighten-4':''"
                    label="Turno"
                    dense
                    :items="allShifts"
                    v-model="activeSlots[si+ci*mid].shiftId"
                    return-object
                    name="shiftName"
                    outlined
                    hide-details
                    >
                  </v-select>                
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-row>
      </v-card>
  </v-form>
  <v-dialog v-model="dialog_instruction" max-width="800">
      <v-card>
          <v-card-title class="text-h5 mb-1">
            Istruzioni
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-5 mt-1 mb-0 pb-3">
              <v-col md="6" cols="12">
                  <p>
                      Ai fini di una migliore visualizzazione, attribuite ad ogni slot un Turno: potete scegliere uno dei valori proposti oppure Inserire un nome a Piacere.
                  </p>
                  <p>
                    Si consiglia di utilizzareIn questo modo, in "Gestione Tavoli", i turni verranno mostrati in sottofinestre separate
                  </p>
              </v-col>
              <v-col md="6" cols="12">
                  <p>
                    Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                  </p>
                  <p>
                    Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                  </p>
              </v-col>
              <v-col cols="12">
                  <p color="error">
                      <strong>Attenzione:</strong> Se premete il tasto Salva dalla sezione '15 Minuti' gli slots della sezione '30 Minuti' vengono cancellati e viceversa
                  </p>

              </v-col>
          </v-row>
      </v-card>
  </v-dialog>
</div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      allShifts:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      cols:4,
      mid:0
    };
  },
  computed : {
    ...mapGetters(["settings"]),
      Columns () {
      let columns = []
      this.mid = Math.ceil(this.activeSlots.length / this.cols)
      let mid=this.mid;
      for (let col = 0; col < this.cols; col++) {
        columns.push(this.activeSlots.slice(col * mid, col * mid + mid))
      }/*
      for (let i = 0; i < this.activeSlots.length; i += this.cols) {
          columns.push( array.slice(i, i + this.cols));
      }*/
      console.log(144,columns)
      return columns
    }
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
    async saveActiveSlots()
    {
        this.loading_update=true;
        console.log(255,this.form);
        let payload={"action":"saveItem","table":"SlotsShiftId","payload":this.activeSlots};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.getData();
            //this.coversByDOW_hash=JSON.stringify(this.coversByDOW);
        }   
    },
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllShifts_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading= false;
                switch (res.data.errorid)
                {
                  case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.allShifts=res.data.payloads.allShifts;
                    this.activeSlots=res.data.payloads.activeSlots;
                    this.activeSlots_hash=JSON.stringify(this.activeSlots);
                    //this.tabs=res.data.allSlots.map(item => item.clockStep).filter((value, index, self) => self.indexOf(value) === index)
                    console.log(282,this.allShifts,this.activeSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
          console.log(e);
          this.loading= false;
          this.dialog_connection_error=true;      
        }
    }
  },
};
</script>